/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useMemo } from 'react';
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { saveOnBoardData } from 'api/onBoarding';
import BusinessGridItem from 'accountSetup/FormFields/BusinessGridItem';
import BusinessCategoryModal from 'accountSetup/FormFields/BusinessCategoryModal';
import APModal from 'components/Modal/APModal';
import './styles.scss';

import EventPlanning from 'assets/images/account_setup/event-planning.png';
import Venue from 'assets/images/account_setup/venue.png';
import Photography from 'assets/images/account_setup/photography.png';
import Videography from 'assets/images/account_setup/videography.png';
import FloralDesign from 'assets/images/account_setup/floral-design.png';
import EventDesign from 'assets/images/account_setup/event-design.png';
import Stationery from 'assets/images/account_setup/stationery.png';
import Calligraphy from 'assets/images/account_setup/calligraphy.png';
import Officiant from 'assets/images/account_setup/officiant.png';
import Beauty from 'assets/images/account_setup/beauty.png';
import Entertainment from 'assets/images/account_setup/entertainment.png';
import Catering from 'assets/images/account_setup/catering.png';
import BartendingServices from 'assets/images/account_setup/bartending-services.png';
import EventStaffing from 'assets/images/account_setup/event-staffing.png';
import CakesAndDesserts from 'assets/images/account_setup/cakes-and-desserts.png';
import EventRentals from 'assets/images/account_setup/event-rentals.png';
import LightingAndDecor from 'assets/images/account_setup/lighting-and-decor.png';
import GiftsAndFavors from 'assets/images/account_setup/gifts-and-favors.png';
import RegistryServices from 'assets/images/account_setup/registry-services.png';
import Transportation from 'assets/images/account_setup/transportation.png';
import DressAndAttire from 'assets/images/account_setup/dress-and-attire.png';
import JewelryAndAccessories from 'assets/images/account_setup/jewelry-and-accessories.png';
import HealthAndWellness from 'assets/images/account_setup/health-and-wellness.png';
import HoneymoonAndTravel from 'assets/images/account_setup/honeymoon-and-travel.png';
import Accommodation from 'assets/images/account_setup/accommodations.png';
import UniqueProductOrService from 'assets/images/account_setup/unique-product-or-service.png';
import Other from 'assets/images/account_setup/other.png';
import { getPutFormat } from './filter';

const gridItems = {
  event_planning: {
    url: EventPlanning,
    text: 'Event Planning',
    selected: false,
    listing_category_id: 1,
  },
  venue: { url: Venue, text: 'Venue', selected: false, listing_category_id: 2 },
  photography: {
    url: Photography,
    text: 'Photography',
    selected: false,
    listing_category_id: 3,
  },
  videography: {
    url: Videography,
    text: 'Videography',
    selected: false,
    listing_category_id: 27,
  },
  floral_design: {
    url: FloralDesign,
    text: 'Floral Design',
    selected: false,
    listing_category_id: 4,
  },
  event_design: {
    url: EventDesign,
    text: 'Event Design',
    selected: false,
    listing_category_id: 5,
  },
  stationery: {
    url: Stationery,
    text: 'Stationery',
    selected: false,
    listing_category_id: 13,
  },
  calligraphy: {
    url: Calligraphy,
    text: 'Calligraphy',
    selected: false,
    listing_category_id: 18,
  },
  officiant: {
    url: Officiant,
    text: 'Officiant',
    selected: false,
    listing_category_id: 9,
  },
  beauty: {
    url: Beauty,
    text: 'Beauty',
    selected: false,
    listing_category_id: 10,
  },
  entertainment: {
    url: Entertainment,
    text: 'Entertainment',
    selected: false,
    listing_category_id: 8,
  },
  catering: {
    url: Catering,
    text: 'Catering',
    selected: false,
    listing_category_id: 6,
  },
  bartending_services: {
    url: BartendingServices,
    text: 'Bartending Services',
    selected: false,
    listing_category_id: 17,
  },
  event_staffing: {
    url: EventStaffing,
    text: 'Event Staffing',
    selected: false,
    listing_category_id: 20,
  },
  cakes_desserts: {
    url: CakesAndDesserts,
    text: 'Cakes & Desserts',
    selected: false,
    listing_category_id: 11,
  },
  event_rentals: {
    url: EventRentals,
    text: 'Event Rentals',
    selected: false,
    listing_category_id: 7,
  },
  lighting_decor: {
    url: LightingAndDecor,
    text: 'Lighting & Decor',
    selected: false,
    listing_category_id: 14,
  },
  gifts_favors: {
    url: GiftsAndFavors,
    text: 'Gifts & Favors',
    selected: false,
    listing_category_id: 21,
  },
  registry_services: {
    url: RegistryServices,
    text: 'Registry Services',
    selected: false,
    listing_category_id: 24,
  },
  transportation: {
    url: Transportation,
    text: 'Transportation',
    selected: false,
    listing_category_id: 25,
  },
  dress_attire: {
    url: DressAndAttire,
    text: 'Dress & Attire',
    selected: false,
    listing_category_id: 19,
  },
  jewelry_accessories: {
    url: JewelryAndAccessories,
    text: 'Jewelry & Accessories',
    selected: false,
    listing_category_id: 23,
  },
  health_wellness: {
    url: HealthAndWellness,
    text: 'Health & Wellness',
    selected: false,
    listing_category_id: 22,
  },
  honeymoon_travel: {
    url: HoneymoonAndTravel,
    text: 'Honeymoon & Travel',
    selected: false,
    listing_category_id: 15,
  },
  accomodation: {
    url: Accommodation,
    text: 'Accommodation',
    selected: false,
    listing_category_id: 16,
  },
  unique: {
    url: UniqueProductOrService,
    text: 'Unique Product Or Service',
    selected: false,
    listing_category_id: 26,
  },
  other: {
    url: Other,
    text: 'Other',
    selected: false,
    other_categories: '',
    listing_category_id: null,
  },
};

// No selection limit for now, can adjust later if needed
const GRID_ITEMS_LIMIT = Infinity;

const Step4 = ({ formData, businessTypeMode = 'secondary' }) => {
  const history = useHistory();
  const [isSubmitted, setFormSubmitted] = useState(false);

  const isPrimaryMode = useMemo(() => businessTypeMode === 'primary',[businessTypeMode]);

  const [primaryBusinessType, setPrimaryBusinessType] = useState(null);
  const [secondaryBusinessTypes, setSecondaryBusinessTypes] = useState([]);
  const [categories, setCategories] = useState({});
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);

  useEffect(() => {
    const { companyInfo } = formData;
    if (!companyInfo) return;

    const [primary, ...secondary] = companyInfo.businessType;

    setPrimaryBusinessType(primary);
    setSecondaryBusinessTypes(secondary);

    const selectedTypes = isPrimaryMode && primary ? [primary] : secondary;
    const updated = getBusinessTypes(selectedTypes, isPrimaryMode, primary);
    setCategories(updated);
  }, [formData.companyInfo, isPrimaryMode]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [businessTypeMode]);

  const handleCategoryClick = (item) => {
    item.selected = !item.selected;

    const businessType = {
      name: item.text,
      listing_category_id: item.listing_category_id,
    };

    if (isPrimaryMode) {
      const updatedSecondary = secondaryBusinessTypes.filter(
        (type) => type.listing_category_id !== item.listing_category_id);

      setPrimaryBusinessType(businessType);
      setSecondaryBusinessTypes(updatedSecondary);
      setCategories(getBusinessTypes([businessType], true, businessType));

      return;
    }

    // Secondary mode
    const updatedSecondary = item.selected
      ? [...secondaryBusinessTypes, businessType]
      : secondaryBusinessTypes.filter((type) => type.listing_category_id !== item.listing_category_id);

    setSecondaryBusinessTypes(updatedSecondary);
    setCategories(getBusinessTypes(updatedSecondary, false, primaryBusinessType));
  };

  const handleOtherCategorySave = (value) => {
    const otherType = {
      listing_category_id: null,
      name: value,
    };

    if (isPrimaryMode) {
      const updatedSecondary = secondaryBusinessTypes.filter((type) => type.listing_category_id !== null);

      setPrimaryBusinessType(otherType);
      setSecondaryBusinessTypes(updatedSecondary);
      setCategories(getBusinessTypes([otherType], true, otherType));

      return;
    }

    const isOtherIncluded = secondaryBusinessTypes.some((type) => type.listing_category_id === null);
    const updatedSecondary = isOtherIncluded
      ? secondaryBusinessTypes.map((type) => type.listing_category_id === null ? otherType : type)
      : [...secondaryBusinessTypes, otherType];

    setSecondaryBusinessTypes(updatedSecondary);
    setCategories(getBusinessTypes(updatedSecondary, false, primaryBusinessType));
  };

  const closeModal = (value) => {
    setOpenCategoryModal(false);
    if (value === '') {
      categories.other.selected = false;
      categories.other.other_categories = '';
    } else if (value === categories.other.other_categories) {
      categories.other.selected = true;
    }
  };

  const isFormFieldsValid = () => {
    const selected = Object.values(categories).filter((item) => item.selected);

    if (isPrimaryMode) {
      return selected.length > 0;
    }

    // Secondary business types are optional
    return true;
  };

  const saveForms = async () => {
    const newFormData = formData;
    newFormData.companyInfo.businessType = primaryBusinessType
      ? [primaryBusinessType, ...secondaryBusinessTypes]
      : [...secondaryBusinessTypes];

    const result = await saveOnBoardData({
      boarding: getPutFormat(newFormData),
    });
    return result;
  };

  const handleBack = () => {
    if (isPrimaryMode) {
      history.push('/app/v2/account-setup/step/3');
    } else {
      history.push('/app/v2/account-setup/step/4');
    }
  };

  const handleNext = async () => {
    setFormSubmitted(true);

    if (isFormFieldsValid()) {
      await saveForms();

      if (isPrimaryMode) {
        history.push('/app/v2/account-setup/step/5');
      } else {
        history.push('/app/v2/account-setup/step/6');
      }
    }
  };

  const onCategoryCheck = (item, items) => {
    const selectedItems = Object.keys(items).filter((key) => items[key].selected);

    if (selectedItems.length >= GRID_ITEMS_LIMIT && !item.selected) {
      setOpenErrorModal(true);
      return;
    }

    if (item.text === 'Other' && !item.selected) {
      setOpenCategoryModal(true);
    } else {
      handleCategoryClick(item, items);
    }
  };

  return (
    <>
      <section className="stepflow_content">
        <article className="stepflow_form">
          <section className="stepflow_form-header">
            <h3 className="form-title">
              {isPrimaryMode
                ? 'Primary business type'
                : 'Secondary business types'}
            </h3>
            <p className="form-subtitle text-center">
              Help us get to know your business so we can customize your
              experience and make you feel right at home.
            </p>
          </section>

          <div className="stepflow__services">
            <div className="stepflow_form__label font-weight-bold">
              {isPrimaryMode &&
                'What primary service do you offer? Select one.'}
              {!isPrimaryMode &&
                'What other services do you offer? Select all that apply.'}
            </div>
            <div className="business-grid">
              {Object.keys(categories).map((item, key) => (
                <BusinessGridItem
                  key={key}
                  index={key}
                  items={categories}
                  item={categories[item]}
                  itemName={item}
                  setCategories={() =>
                    onCategoryCheck(categories[item], categories)
                  }
                />
              ))}
            </div>
          </div>
          <BusinessCategoryModal
            open={openCategoryModal}
            onClose={(value) => closeModal(value)}
            onSave={handleOtherCategorySave}
            item={categories.other}
          />
        </article>
      </section>
      <section className="stepflow_footer">
        <button className="stepflow_footer-button"
          onClick={handleBack}
        >
          <BsArrowLeftShort size={20} /> Back
        </button>
        {isSubmitted && !isFormFieldsValid() && (
          <div className="stepflow_footer-error">
            Please choose the primary service type.
          </div>
        )}
        <button
          className="stepflow_footer-button"
          color="primary"
          onClick={handleNext}
        >
          Next
          <BsArrowRightShort size={20} />
        </button>
      </section>
      <APModal
        open={openErrorModal}
        onClose={() => setOpenErrorModal(false)}
        name="account-setup-step2"
        title="Heads up!"
      >
        <div className="content-container content-container--narrow">
          You've reached the max of six items. Please remove existing items to
          free up space before adding new items.
        </div>
        <button className="button"
          onClick={() => setOpenErrorModal(false)}
        >
          Got it
        </button>
      </APModal>
    </>
  );
};

export default Step4;

const getBusinessTypes = (selectedTypes, isPrimaryMode, primaryType = null) => {
  if (isPrimaryMode && (!selectedTypes || selectedTypes.length === 0)) {
    return gridItems;
  }

  const newGridItems = { ...gridItems };

  const findTypeKeyByText = (items, text) => {
    const index = Object.values(items).findIndex((item) => item.text === text);
    return index > -1 ? Object.keys(items)[index] : null;
  };
  const findTypeKeyByCategoryId = (items, id) => {
    const index = Object.values(items).findIndex(
      (item) => item.listing_category_id === id);
    return index > -1 ? Object.keys(items)[index] : null;
  };

  // Reset selection and remove any disabled flags before re-applying
  Object.values(newGridItems).forEach((item) => {
    item.selected = false;
    delete item?.disabled;
  });

  selectedTypes.forEach((type) => {
    // For 'Other' case
    if (type.listing_category_id === null) {
      const otherKey = findTypeKeyByText(newGridItems, 'Other');
      if (otherKey) {
        newGridItems[otherKey].selected = true;
        newGridItems[otherKey].other_categories = type.name || '';
      }

      return;
    }

    const objectKey = findTypeKeyByCategoryId(newGridItems, type.listing_category_id);
    if (objectKey) {
      newGridItems[objectKey].selected = true;
    }
  });

  // Disable the primary category in secondary mode
  if (!isPrimaryMode && primaryType) {
    const primaryKey = findTypeKeyByCategoryId(gridItems, primaryType.listing_category_id);
    if (primaryKey) {
      newGridItems[primaryKey].disabled = true;
    }
  }

  return newGridItems;
};
